import { NoteProperty } from "src/components";
import { IssueDto, useEditIssueNote } from "src/http";

interface Props {
  issue: IssueDto;
}

const IssueNoteProperty = (props: Props) => {
  const { mutate: editIssueNote, isLoading } = useEditIssueNote();

  function handleSaveClicked(note: string) {
    editIssueNote({
      issueGuid: props.issue.guid,
      note,
      teamSlug: props.issue.assignedTeam?.slug,
      createdByUser: props.issue.createdByUser,
    });
  }

  return (
    <NoteProperty
      note={props.issue.note}
      userCanEdit={props.issue.userCanEditOtherProperties}
      disabled={isLoading}
      onSaveClicked={handleSaveClicked}
    />
  );
};

export { IssueNoteProperty };
